export const LoginInitBar = ({ bgColor }: { bgColor: string }) => (
  <div
    className={`${bgColor} h-4 rounded-full animated-progress mt-10`}
    style={{
      backgroundImage:
        'linear-gradient(' +
          '45deg, ' +
          'hsla(0,0%, 100%, .15) 25%, ' +
          'transparent 0, ' +
          'transparent 50%, ' +
          'hsla(0,0%,100%,.15) 0,' +
          'hsla(0, 0%, 100%, .15) 75%, ' +
          'transparent 0, transparent' +
        ')',
      backgroundSize: '1rem 1rem',
    }}
  />
)
